export enum LocalStorageKeys {
  AppState = 'ClaimsAppState',
  OdsShipmentResp = 'OdsShipmentResp',
  ActiveUserRole = 'ActiveUserRole',
}
